<style scoped> 
   
.info-box {
    height: 100px; /* Fija la altura */
    overflow: auto; /* Permite el scroll si el contenido excede la altura */
    white-space: pre-line; /* Para manejar los saltos de línea de manera adecuada */
    padding: 15px; /* Espacio interno más generoso */
    border: 1px solid #ddd; /* Borde más sutil */
    border-radius: 8px; /* Bordes redondeados */
    font-size: 14px; /* Tamaño de fuente */
    line-height: 1.6; /* Mayor espaciado entre líneas para mejorar la legibilidad */
    background-color: #f4f6f9; /* Color de fondo más suave */
    width: 100%; /* Ajusta el ancho */
    box-sizing: border-box; /* Padding no afecta el tamaño total */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Sombra suave para darle profundidad */
    color: #333; /* Color del texto */
}

.info-box:focus {
    outline: none; /* Quita el borde predeterminado del input al enfocarse */
    border-color: #a0d1fb; /* Color de borde más vibrante al enfocarse */
    box-shadow: 0 0 6px rgba(32, 150, 243, 0.5); /* Sombra más vibrante al enfocarse */
}

.label {
    font-weight: 600;
}

.label-custom{
    font-weight: 600;
    font-style: italic;
}

.custom-radio .form-check-input {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.custom-radio .form-check-label {
    margin-left: 10px;
    font-size: 16px;
}

.custom-radio .form-check-input:checked {
    background-color: #007bff;
    border-color: #007bff;
}

.custom-radio .form-check-input:focus {
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
}

.input-container {
    display: flex;
    align-items: center;
    width: 100%; /* Ocupa todo el ancho disponible */
}

.identifier-box {
    background-color: #f0f0f0;
    padding: 0.5rem;
    border: 1px solid #ccc;
    font-size: 12px;
    font-weight: bold;
    min-width: 50px; /* Ancho fijo para el número */
    display: flex;
    justify-content: center;
    align-items: center;
    height: 43px;
}

.select-wrapper {
    flex-grow: 1; /* Permite que el select ocupe todo el espacio restante */
}

app-input {
    width: 100%; /* Asegura que el select ocupe todo el ancho disponible en su contenedor */
    box-sizing: border-box; /* Asegura que padding y borde se consideren en el ancho total */
}
</style>
<template>
    <div class="col-md-12 col-xs-12 mb-4">
		<label class="label">{{ $t("How many ship address are you required ?") }}</label>
		<br />
		<div class="form-check form-check-inline custom-radio" v-for="n in num" :key="n" >
			<input
				class="form-check-input"
				type="radio"
				:id="'inlineRadio' + n"
				v-model="selected"
				:value="n"
                :disabled="read"
			/>
		    <label class="form-check-label" :for="'inlineRadio' + n"> {{ getLetterFromIndex(n-1) }} </label>
		</div>
	</div>
</template>
  
<script>
    export default {
        name: 'AddressRequired',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
            read : {
                type : Boolean,
                default : false
            },
            num : {
                type : Number,
                default : 2,
            } 
        },
        methods : {
            getLetterFromIndex(index) {
                if (typeof index !== 'number' || index < 0) {
                    return ''; // Manejo de error o valor inválido
                }
                return String.fromCharCode(65 + Math.floor(index));
            },
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>